module.exports = "https://cdn.realtymogul.com/static/media/HP_card_brooklyn_portfolio.341f47c7.jpg";